import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux'
import { ButtonGroup, Button } from 'reactstrap';
import { Link } from "react-router-dom";
import SectorForm from '../SectorForm/SectorForm';
import PageTitle from '../../../components/PageTitle/PageTitle';
import { Utils } from '../../../services';
import { loadSector, updateSector } from '../../../redux/modules/sectors';

const SectorEdit = ({ match }) => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        const sectorId = match.params.sectorId;
        // Load sector on component mount
        dispatch(loadSector(sectorId));
    }, [dispatch])

    const submit = (values) => {
        dispatch(updateSector(values));
    }

    const { sector } = useSelector(state => state.sectors);

    let title = <span>{t('sectors.update_sector')}</span>;

    if (sector && sector.name)
        title = (
            <span>
                {t('sectors.sector', {count: 1})}
                <small> |&nbsp;{ t('sectors.update_sector', { name: sector.name[Utils.default_lang()] })} </small>
            </span>
        );

    const actions =
        <div>
            {sector &&
            <ButtonGroup>
                <Button  tag={Link} to="/sectors" color="warning" size="sm">
                    <i className="fa fa-arrow-left"></i>&nbsp;{t('common.back')}
                </Button>
            </ButtonGroup>
            }
        </div>

        return (
            <div className="SectorEdit">
                <PageTitle icon="location-arrow" title={ title } actions={ actions } />

                {sector &&
                    <SectorForm sectorId={sector._id} onSubmit={ submit } />
                }
            </div>
        );
}

export default SectorEdit;
